import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/book-info-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-c5a9076a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "guidance-link",
  "data-test": "guidance-button"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "guidance link",
  class: "guidance-icon-img",
  "data-test": "guidance-image"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { Tooltip } from "uiv";
import { computed } from "vue";
import { isMobile } from "mobile-device-detect";


export default /*#__PURE__*/_defineComponent({
  __name: 'guidance-button',
  props: {
    link: {},
    tooltipText: {},
    imgWidth: {},
    tooltipTarget: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0010e27d": (imageWidth.value)
}))

const props = __props;

const imageWidth = computed(() => {
  return props.imgWidth ?? "50px";
});

const isMobileView = computed(() => {
  return isMobile;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: props.link,
      "data-test": "guidance-link"
    }, _hoisted_4, 8, _hoisted_2),
    (props.tooltipText && !isMobileView.value)
      ? (_openBlock(), _createBlock(_unref(Tooltip), {
          key: 0,
          text: props.tooltipText,
          target: props.tooltipTarget,
          "data-test": "guidance-tooltip"
        }, null, 8, ["text", "target"]))
      : _createCommentVNode("", true)
  ]))
}
}

})